import React, { useState } from 'react';
import Modal from './Modal';
import Input from './Input';
import Button from './Button';
import { useAuth } from '../../contexts/AuthContext';
import UsuariosServiceAPI from '../../services/usuariosServiceAPI';
import fotoPerfilService from '../../services/fotoPerfilService';

const EditarPerfilModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => {
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    nome: user?.nome || '',
    email: user?.email || '',
    telefone: '',
    foto_perfil: user?.foto_perfil || ''
  });
  const [loading, setLoading] = useState(false);
  const [uploadingFoto, setUploadingFoto] = useState(false);

  const handleFotoChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file || !user) return;

    try {
      setUploadingFoto(true);
      const { url, error } = await fotoPerfilService.uploadFotoPerfil(file, user.id);

      if (error) {
        alert('Erro ao fazer upload da foto: ' + error);
        return;
      }

      if (url) {
        setFormData({ ...formData, foto_perfil: url });
      }
    } catch (error) {
      console.error('Erro ao fazer upload da foto:', error);
      alert('Erro ao fazer upload da foto');
    } finally {
      setUploadingFoto(false);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!user) return;

    try {
      setLoading(true);
      await UsuariosServiceAPI.atualizar(user.id, {
        nome: formData.nome,
        email: formData.email,
        telefone: formData.telefone,
        foto_perfil: formData.foto_perfil
      });

      alert('Perfil atualizado com sucesso!');
      
      // Buscar dados atualizados do banco
      const usuarioAtualizado = await UsuariosServiceAPI.buscarPorId(user.id);
      
      if (usuarioAtualizado) {
        // Atualizar usuário no contexto
        const updatedUser = {
          id: user.id,
          email: usuarioAtualizado.email || user.email,
          nome: usuarioAtualizado.nome,
          perfil: user.perfil,
          filiais: user.filiais,
          ativo: user.ativo,
          created_at: user.created_at,
          updated_at: user.updated_at,
          primeiro_acesso: usuarioAtualizado.primeiro_acesso,
          foto_perfil: usuarioAtualizado.foto_perfil
        };
        localStorage.setItem('user', JSON.stringify(updatedUser));
        window.location.reload();
      }
      
      onClose();
    } catch (error) {
      console.error('Erro ao atualizar perfil:', error);
      alert('Erro ao atualizar perfil');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Editar Meu Perfil" size="md">
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Foto de Perfil */}
        <div className="flex flex-col items-center space-y-4">
          <div className="relative">
            {formData.foto_perfil ? (
              <img
                src={formData.foto_perfil}
                alt="Foto de perfil"
                className="h-24 w-24 rounded-full object-cover border-4 border-primary-500"
              />
            ) : (
              <div className="h-24 w-24 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center border-4 border-primary-500">
                <span className="text-white font-bold text-3xl">
                  {formData.nome.charAt(0).toUpperCase()}
                </span>
              </div>
            )}
            <label className="absolute bottom-0 right-0 bg-blue-600 hover:bg-blue-700 text-white p-2 rounded-full cursor-pointer transition-colors">
              <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <input
                type="file"
                accept="image/*"
                onChange={handleFotoChange}
                className="hidden"
                disabled={uploadingFoto}
              />
            </label>
          </div>
          <p className="text-xs text-gray-500">JPG, PNG, GIF ou WebP (máx. 5MB)</p>
        </div>

        <Input
          label="Nome de Exibição"
          value={formData.nome}
          onChange={(value) => setFormData({ ...formData, nome: value })}
          required
        />
        <Input
          label="E-mail"
          type="email"
          value={formData.email}
          onChange={(value) => setFormData({ ...formData, email: value })}
          required
        />
        <Input
          label="Telefone"
          type="tel"
          value={formData.telefone}
          onChange={(value) => setFormData({ ...formData, telefone: value })}
          placeholder="(00) 00000-0000"
        />

        <div className="flex justify-end gap-3 pt-4">
          <Button variant="outline" onClick={onClose} disabled={loading || uploadingFoto}>
            Cancelar
          </Button>
          <Button type="submit" loading={loading || uploadingFoto} disabled={loading || uploadingFoto}>
            Salvar Alterações
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default EditarPerfilModal;
